import type { RouteLocationRaw } from 'vue-router'
import type { MessageSendableType } from '~/types'
import { MessageableMessageList } from '~/constants'

export function makeMessageRoute(
  id: string,
  type: MessageSendableType = 'event',
): RouteLocationRaw {
  return {
    name: MessageableMessageList,
    params: {
      type,
      id,
    },
  }
}

export function makeMessageAutomationRoute(
  id: string,
  type: MessageSendableType = 'event',
): RouteLocationRaw {
  return {
    name: 'MessagesAutomation',
    params: {
      type,
      id,
    },
  }
}

export function makeMessageEditRoute(
  parentId: string,
  messageId: string,
  type: MessageSendableType = 'event',
  channel = 'sms',
): RouteLocationRaw {
  return {
    name: channel.toLowerCase() === 'sms' ? 'MessageSMS' : 'MessageEmail',
    params: {
      type,
      message_id: messageId,
      id: parentId,
    },
  }
}

export function makeEmailMessageEditRoute(
  parentId: string,
  messageId: string,
  type: MessageSendableType = 'event',
): RouteLocationRaw {
  return makeMessageEditRoute(parentId, messageId, type, 'email')
}

export function makeSMSMessageEditRoute(
  parentId: string,
  messageId: string,
  type: MessageSendableType = 'event',
): RouteLocationRaw {
  return makeMessageEditRoute(parentId, messageId, type, 'sms')
}

export function getPreviousPageFromRouter(router = useRouter()) {
  return router.options.history?.state?.back as string | undefined
}
